import { APIHOST } from '../common'
import { ContactInformationSaveData } from '../pages/registration/ContactInformation';
import { BillingInformationSaveData } from '../pages/registration/BillingInformation';
import { Order } from '../types/order';
import { RoomRequirmentsSaveData } from '../pages/registration/RoomRequirements';

export interface OrderFormProps {
  orderId: string;
  type: 'step' | 'dialog';
  back?: () => void;
  onSave?: () => void;
  onStepComplete?: () => void;
}



//Save or update order
export const saveOrder = async (saveOrderInput: ContactInformationSaveData | BillingInformationSaveData | RoomRequirmentsSaveData) => {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) return false;

    const {orderId, ...body} = saveOrderInput;
    const method = 'PUT';
    const url = `${APIHOST}/api/orders/${orderId}`;

    return fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      body: JSON.stringify({
        data: body
      })})
      .then(response => response.ok)
  };

  export const fetchOrder = async (orderId: string): Promise<Order|null> => {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) return null;

    const url = `${APIHOST}/api/orders/${orderId}?populate[]=conference_group.conference&populate[]=conference_hotel&populate[]=conference_hotel.hotel&populate[]=order_rooms&populate[]=order_rooms.order_room_occupants&populate[]=order_rooms.conference_hotel_room`;

    return fetch(url, {
      headers: {
        'Authorization': `Bearer ${authToken}`
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch order');
      }
      return response.json();
    })
    .then(data => {
      console.log('Fetched order data:', data);
      return data.data;
    })
    .catch(error => {
      console.error('Error fetching order:', error);
      return null;
    });
  }